import React from 'react';
import { Hero } from './components/Hero';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { First30Days } from './components/First30Days';
import { MethodOverview } from './components/MethodOverview';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Guarantee, Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { ValueStack } from './components/ValueStack';
import { EmotionalClose } from './components/EmotionalClose';
export function App() {
  return <div className="min-h-screen text-brand-text font-sans selection:bg-brand-rose/30 selection:text-brand-rose bg-brand-surface" data-id="element-0">
      <Hero data-id="element-1" />
      <InitialTestimonials data-id="element-2" />
      <PainPoints data-id="element-3" />
      <MethodOverview data-id="element-4" />
      <First30Days data-id="element-5" />
      <ValueStack data-id="element-6" />
      <CostComparison data-id="element-7" />
      <MoreTestimonials data-id="element-8" />
      <Pricing data-id="element-9" />
      <Guarantee data-id="element-10" />
      <FAQ data-id="element-11" />
      <EmotionalClose data-id="element-12" />
      <Footer data-id="element-13" />
      <FloatingNotification data-id="element-14" />
    </div>;
}